/**
 * Identity of this app in the shared product-access system.
 *
 * When porting product-access.service.ts / product-disabled page to another
 * Crewdle product, only these constants need to change.
 */
export const PRODUCT_ID = 'ai-studio';
export const PRODUCT_NAME = 'Crewdle Forge';
